import * as React from "react";
import * as FormUtils from '../formUtils/index';
import { UserELP } from '../../models/UserELP';
import { ELP } from '../../models/ELP';
import { Button, Col, Row, Tooltip } from "reactstrap";
import { FormikProps, FormikValues } from "formik";
import { useState } from "react";
import { ELPService } from '../../services/ELPService';
import { formatDate, formatDateAndTime } from "../../utils";
//import AuthenticationContext from "../context/AuthenticationContext";
//import { useContext } from "react";

interface IProps {
    values: UserELP;
}

type LookupItem = {
    value: number;
    text: string;
}

const Situations: LookupItem[] = [{
    value: 1,
    text: 'A. Previous/Current CPSA practice permit has been obtained'
}, {
    value: 2,
    text: 'B. My undergraduate or postgraduate medical education experience is in a country where English is the first and native language (see above for approved list as per CPSA)'
}, {
    value: 3,
    text: 'C. More than 50% of my undergraduate and postgraduate medical education (including residency and clinical fellowship training) was taken in a country where English is the first and native language (see above for approved list as per CPSA)'
}, {
    value: 4,
    text: 'D. I am in independent practice in Canada or in a country where English is the first and native language (see above for list as approved by CPSA) and have already met ELP requirements before registering with your regulatory body'
}, {
    value: 5,
    text: 'E. I have obtained a previous exemption letter from the AIMG Program'
    }];

const Responses: LookupItem[] = [{
    value: 1,
    text: 'You answered (A) above that you have previous/current practice permit with the CPSA, please indicate your practice permit number below. There is no need to complete this survey. Simply upload a copy of your CPSA practice permit in your supporting documents upload.'
}, {
    value: 1,
    text: 'You answered(B or C) above that you have undergraduate or postgraduate MEDICAL EDUCATION experience in a country where English is the first and native language, please indicate what country is on your medical degree.This also applies to the 50% or more option.We will be in contact with you to request your clinical rotation schedule(with location and dates) and a copy of your medical degree.'
}, {
    value: 1,
    text: 'You answered(D) above that you are in independent practice in Canada or in a country where English is the first and native language, please indicate below where your licensure has been obtained.'
}, {
    value: 1,
    text: 'You answered(E) above please upload a copy of your exemption letter in the supporting documents upload page and no further action is required.You are not required to fill out this survey.'
}];

export function UserELPAdminFields(props: FormikProps<FormikValues>) {

    const values = props.values as UserELP;

    //const authCtx = useContext(AuthenticationContext);

    const isReadOnly = values.userProfileId.length > 0;
    // const isReadOnly = false;

    return (<React.Fragment>

        <div className="form-section">

            <div className="card mb-3 p-3">
                <h3>English Language Proficiency</h3>
                <Row>
                    <Col sm="12" md="12">
                        <FormUtils.GroupSetDropdown<LookupItem>
                            fieldName="situationId"
                            title="Check the box that BEST describes your situation:"
                            dropdownProps={{
                                dataSource: Situations,
                                getId: x => x.value,
                                renderItem: x => x.text,
                                renderSelectedItem: x => x.text,
                                selectedValue: values.situationId
                            }}
                            disabled={true}
                        />
                        
                    </Col>
                    
                </Row>

                <Row>
                    <Col sm="12" md="12">
                        <FormUtils.GroupSetTextArea
                            fieldName="description"
                            title="Please explain your situation further. Only forms with a detailed explanation will be reviewed. (1000 characters max)"
                            disabled={true}
                            controlSize="large"
                        />
                    </Col>
                </Row>

                <Row>
                    <Col sm="12" md="12">
                        <p><strong>I certify the above information is correct. I understand the instructions provided, and I will provide the required supporting documents.</strong></p>
                        <FormUtils.GroupSetCheckbox
                            fieldName="agree"
                            title="I Agree"
                            explanationText=""
                            disabled={true}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col sm="12" md="12">
                        <FormUtils.GroupSetDropdownAsync<ELP, number>
                            fieldName="elpId"
                            title="Status"
                            dropdownProps={{
                                loadDataSource: () => ELPService.list(),
                                getId: x => x.id,
                                renderItem: x => x.value,
                                renderSelectedItem: x => x.value,
                                selectedValue: values.elpId,
                                allowNullSelection: true,
                                nullSelectionText: 'Select'
                            }}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col sm="12" md="12">
                        <FormUtils.GroupSetTextArea
                            fieldName="userLetter1"
                            title="AE Decision Letter 1"
                            disabled={false}
                            controlSize="large"
                        />
                    </Col>
                </Row>

                <Row>
                    <Col sm="12" md="12">
                        <FormUtils.GroupSetTextArea
                            fieldName="adminNote1"
                            title="Admin Note 1 (Not shared with the client)"
                            disabled={false}
                            controlSize="large"
                        />
                    </Col>
                </Row>

                <></>

                <hr />

                <FormUtils.GroupSetCheckbox
                    fieldName="hasAE2"
                    title="Add Another ELP"
                    explanationText=""
                    disabled={true}
                />

                {values.hasAE2 && <>
                    <h3>Administrative Exception 2</h3>
                    <Row>
                        <Col sm="12" md="12">
                            <FormUtils.GroupSetDropdown<LookupItem>
                                fieldName="situationId2"
                                title="Check the box that BEST describes your situation:"
                                dropdownProps={{
                                    dataSource: Situations,
                                    getId: x => x.value,
                                    renderItem: x => x.text,
                                    renderSelectedItem: x => x.text,
                                    selectedValue: values.situationId2
                                }}
                                disabled={true}
                            />

                        </Col>

                    </Row>

                    <Row>
                        <Col sm="12" md="12">
                            <FormUtils.GroupSetTextArea
                                fieldName="description2"
                                title="Please explain your situation further. Only forms with a detailed explanation will be reviewed. (1000 characters max)"
                                disabled={true}
                                controlSize="large"
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col sm="12" md="12">
                            <p><strong>I certify the above information is correct. I understand the instructions provided, and I will provide the required supporting documents.</strong></p>
                            <FormUtils.GroupSetCheckbox
                                fieldName="agree2"
                                title="I Agree"
                                explanationText=""
                                disabled={true}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col sm="12" md="12">
                            <FormUtils.GroupSetDropdownAsync<ELP, number>
                                fieldName="elpId2"
                                title="Status"
                                dropdownProps={{
                                    loadDataSource: () => ELPService.list(),
                                    getId: x => x.id,
                                    renderItem: x => x.value,
                                    renderSelectedItem: x => x.value,
                                    selectedValue: values.elpId2,
                                    allowNullSelection: true,
                                    nullSelectionText: 'Select'
                                }}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col sm="12" md="12">
                            <FormUtils.GroupSetTextArea
                                fieldName="userLetter2"
                                title="AE Decision Letter 2"
                                disabled={false}
                                controlSize="large"
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col sm="12" md="12">
                            <FormUtils.GroupSetTextArea
                                fieldName="adminNote2"
                                title="Admin Note 2 (Not shared with the client)"
                                disabled={false}
                                controlSize="large"
                            />
                        </Col>
                    </Row>

                    <hr />

                    <FormUtils.GroupSetCheckbox
                        fieldName="hasAE3"
                        title="Add Another ELP"
                        explanationText=""
                        disabled={true}
                    />

                    {values.hasAE3 && <>
                        <h3>Administrative Exception 3</h3>
                        <Row>
                            <Col sm="12" md="12">
                                <FormUtils.GroupSetDropdown<LookupItem>
                                    fieldName="situationId3"
                                    title="Check the box that BEST describes your situation:"
                                    dropdownProps={{
                                        dataSource: Situations,
                                        getId: x => x.value,
                                        renderItem: x => x.text,
                                        renderSelectedItem: x => x.text,
                                        selectedValue: values.situationId3
                                    }}
                                    disabled={true}
                                />

                            </Col>

                        </Row>

                        <Row>
                            <Col sm="12" md="12">
                                <FormUtils.GroupSetTextArea
                                    fieldName="description3"
                                    title="Please explain your situation further. Only forms with a detailed explanation will be reviewed. (1000 characters max)"
                                    disabled={true}
                                    controlSize="large"
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col sm="12" md="12">
                                <p><strong>I certify the above information is correct. I understand the instructions provided, and I will provide the required supporting documents.</strong></p>
                                <FormUtils.GroupSetCheckbox
                                    fieldName="agree3"
                                    title="I Agree"
                                    explanationText=""
                                    disabled={true}
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col sm="12" md="12">
                                <FormUtils.GroupSetDropdownAsync<ELP, number>
                                    fieldName="elpId3"
                                    title="Status"
                                    dropdownProps={{
                                        loadDataSource: () => ELPService.list(),
                                        getId: x => x.id,
                                        renderItem: x => x.value,
                                        renderSelectedItem: x => x.value,
                                        selectedValue: values.elpId3,
                                        allowNullSelection: true,
                                        nullSelectionText: 'Select'
                                    }}
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col sm="12" md="12">
                                <FormUtils.GroupSetTextArea
                                    fieldName="userLetter3"
                                    title="AE Decision Letter 3"
                                    disabled={false}
                                    controlSize="large"
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col sm="12" md="12">
                                <FormUtils.GroupSetTextArea
                                    fieldName="adminNote3"
                                    title="Admin Note 3 (Not shared with the client)"
                                    disabled={false}
                                    controlSize="large"
                                />
                            </Col>
                        </Row>
                    </>}
                </>}

            </div>

        </div>

    </React.Fragment>);
}

